import React from "react";
import { Link } from "react-router-dom";

function ProjectCard({ id, icon, title, description, tags, gradient }) {
  const siteUrl =
    id === 1
      ? "https://ommale.com"
      : id === 2
      ? "https://drobalnamaa.com"
      : null;
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="card h-100 border-0 shadow-sm rounded-3 card-hover transition-all">
        <div
          className={`project-card position-relative ${gradient} text-white p-4 d-flex justify-content-center align-items-center`}
          style={{ height: "200px", borderRadius: "15px" }}
        >
          {siteUrl ? (
            <>
              <img src={icon} className="d-block w-100 h-100" alt="logo"></img>
              <div
                className="project-overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
                style={{ borderRadius: "15px" }}
              >
                <div className="d-flex gap-2">
                  <a
                    href={siteUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-light"
                  >
                    عرض الموقع
                  </a>
                  {/* <a href="#" className="btn btn-primary">المصدر</a> */}
                </div>
              </div>
            </>
          ) : (
            <>
              <i className={`${icon} fa-3x`}></i>
              <div
                className="project-overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
                style={{ borderRadius: "15px" }}
              >
                <div className="d-flex gap-2">
                  <Link to={`/project/${id}`} className="btn btn-light">
                    تفاصيل المشروع
                  </Link>
                  {/* <a href="#" className="btn btn-primary">المصدر</a> */}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="card-body p-4">
          <h5 className="card-title fw-bold">{title}</h5>
          <p
            className="card-text text-muted"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
          <div className="d-flex flex-wrap gap-2 mt-3">
            {tags.map((tag, index) => (
              <span key={index} className="badge bg-light text-dark">
                {tag}
              </span>
            ))}
          </div>
          <Link
            hidden={siteUrl}
            to={`/project/${id}`}
            className="btn btn-sm btn-outline-primary mt-3"
          >
            عرض التفاصيل <i className="fas fa-arrow-left me-1"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
